import HierarchyForm from './HierarchyForm';

export default HierarchyForm;
